import Vue from "vue";

import DrayageId from "./drayage-id.vue";
import DrayageAction from "./drayage-action.vue";
import DrayageCustomer from "./drayage-customer.vue";
import DrayageAr from "./drayage-ar.vue";
import DrayageAp from "./drayage-ap.vue";
import DrayageProfit from "./drayage-profit.vue";
import DrayageWarehouseName from "./drayage-warehouse-name.vue";
import DrayageWarehouseCity from "./drayage-warehouse-city.vue";
import DrayageWarehouseState from "./drayage-warehouse-state.vue";
import DrayageTerminals from "./drayage-terminals.vue";
import DrayageDepots from "./drayage-depots.vue";
import DrayageCtype from "./drayage-ctype.vue";
import DrayagePriority from "./drayage-priority.vue";
import DrayageTriaxle from "./drayage-triaxle.vue";
import DrayageHaz from "./drayage-haz.vue";
import DrayageContNo from "./drayage-cont-no.vue";
import DrayageChassisNo from "./drayage-chassis-no.vue";
import DrayageEta from "./drayage-eta.vue";
import DrayageLfd from "./drayage-lfd.vue";
import DrayagePdLfd from "./drayage-pd-lfd.vue";
import DrayageLineLfd from "./drayage-line-lfd.vue";
import DrayageCod from "./drayage-cod.vue";
import DrayageNotifiedAt from "./drayage-notified-at.vue";
import DrayageDispatchComment from "./drayage-dispatch-comment.vue";
import DrayageTasks from "./drayage-tasks.vue";
import DrayageInstructions from "./instructions.vue";
import DrayageStreetTurn from "./drayage-street-turn.vue";

Vue.component("drayage-id", DrayageId);
Vue.component("drayage-action", DrayageAction);
Vue.component("drayage-customer", DrayageCustomer);
Vue.component("drayage-ar", DrayageAr);
Vue.component("drayage-ap", DrayageAp);
Vue.component("drayage-profit", DrayageProfit);
Vue.component("drayage-warehouse-name", DrayageWarehouseName);
Vue.component("drayage-warehouse-city", DrayageWarehouseCity);
Vue.component("drayage-warehouse-state", DrayageWarehouseState);
Vue.component("drayage-terminals", DrayageTerminals);
Vue.component("drayage-depots", DrayageDepots);
Vue.component("drayage-ctype", DrayageCtype);
Vue.component("drayage-priority", DrayagePriority);
Vue.component("drayage-triaxle", DrayageTriaxle);
Vue.component("drayage-haz", DrayageHaz);
Vue.component("drayage-cont-no", DrayageContNo);
Vue.component("drayage-chassis-no", DrayageChassisNo);
Vue.component("drayage-eta", DrayageEta);
Vue.component("drayage-lfd", DrayageLfd);
Vue.component("drayage-pd-lfd", DrayagePdLfd);
Vue.component("drayage-line-lfd", DrayageLineLfd);
Vue.component("drayage-cod", DrayageCod);
Vue.component("drayage-notified-at", DrayageNotifiedAt);
Vue.component("drayage-dispatch-comment", DrayageDispatchComment);
Vue.component("drayage-tasks", DrayageTasks);
Vue.component("drayage-instructions", DrayageInstructions);
Vue.component("drayage-street-turn", DrayageStreetTurn);
